import { ArrowRight } from "lucide-react";
import { BUY_URL } from "./constants";

export const BuyButton = ({
  testId,
  children,
  variant = "solid",
  size = "md",
  className = "",
}) => {
  const sizes = {
    md: "px-7 py-3.5 text-base",
    sm: "px-5 py-2.5 text-sm",
    lg: "px-9 py-4.5 text-lg",
  };
  const variants = {
    solid: "bg-terra text-cream hover:bg-terra-dark",
    outline: "border border-navy/25 text-navy hover:bg-navy hover:text-cream",
    light: "bg-cream text-navy hover:bg-white",
  };
  return (
    <a
      href={BUY_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-full font-body font-semibold transition-[transform,background-color,color,border-color] duration-300 hover:scale-[1.03] active:scale-[0.98] ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
    </a>
  );
};
